import { render, staticRenderFns } from "./TaskStatusBar.vue?vue&type=template&id=5a8fe6b0&scoped=true"
import script from "./TaskStatusBar.vue?vue&type=script&lang=js"
export * from "./TaskStatusBar.vue?vue&type=script&lang=js"
import style0 from "./TaskStatusBar.vue?vue&type=style&index=0&id=5a8fe6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fe6b0",
  null
  
)

export default component.exports